import React from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";
import { v4 as uuid } from "uuid";

import {
  Icon,
  Dialog,
  Classes,
  Button,
  Intent,
  Checkbox,
  FormGroup,
  Callout,
  InputGroup,
  Tag,
} from "@blueprintjs/core";

import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2,
} from "@blueprintjs/table";

import {
  authenticatedGetFetch,
  authenticatedDeleteFetch,
  authenticatedPostFetch,
} from "../../utils/AuthenticatedFetch";

import { methodTag, MultiRouteSelect } from "./RouteSelector";
import { getSetting } from './InstallationSettings'

export default class ApiKeyList extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      delete: {},
      edit: {},
      runningDelete: false,
      loading: false,
      creating: false,
      permFinancial: false,
      permActivity: false,
      permSpv: false,
      permAdmin: false,
      permBonitick: false,
      permExternAccessCtrl: false,
    };
  }

  updateTable() {
    authenticatedGetFetch("/apikeys", (response) => {
      this.setState({ data: response });
    });
  }

  componentDidMount() {
    this.updateTable();
  }

  // reset initial state
  handleClose = () =>
    this.setState({
      runningDelete: false,
      runningPasswordChange: false,
      creating: false,
      pw1: "",
      pw2: "",
      apikey: "",
      loading: false,
      name: "",
      permFinancial: false,
      permActivity: false,
      permSpv: false,
      permAdmin: false,
      permCustomReport: false,
      permBonitick: false,
      permExternAccessCtrl: false,
    });
    

  getTableColumn(){
    const ret = [];

    ret.push((<Column
            id="name"
            cellRenderer={(rowIndex) => (
              <Cell>{this.state.data[rowIndex]["name"]}</Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>login</Trans>} />
            )}
          />));

    ret.push((<Column
            id="insertiondate"
            cellRenderer={(rowIndex) => (
              <Cell>
                {new Date(
                  this.state.data[rowIndex]["insertiondate"]
                ).toLocaleString(i18next.language)}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>creation date</Trans>} />
            )}
          />))

    ret.push((<Column
            id="endvalidity"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["endValidity"] !== null ? (
                  new Date(
                    this.state.data[rowIndex]["endValidity"]
                  ).toLocaleString(i18next.language)
                ) : (
                  <Trans>always valid</Trans>
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>end validity</Trans>} />
            )}
          />));

    ret.push((<Column
            key={"peruf"}
            id="permFinancial"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permFinancial"] ? (
                  <Icon icon="document" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to financial report</Trans>}
              />
            )}
          />));

    ret.push((<Column
            key={"perua"}
            id="permActivity"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permActivity"] ? (
                  <Icon icon="timeline-line-chart" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to activity report</Trans>}
              />
            )}
          />));

    ret.push((<Column
            key={"perus"}
            id="permSpv"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permSpv"] ? (
                  <Icon icon="drive-time" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to the real time supervision</Trans>}
              />
            )}
          />));

    ret.push((<Column
            id="permAdmin"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["isAdmin"] ? (
                  <Icon icon="crown" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>administration permissions</Trans>}
              />
            )}
          />));

    if(getSetting('enable code', false) === true)
      ret.push((<Column
            id="permCode"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permCode"] ? (
                  <Icon icon="crown" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to code</Trans>}
              />
            )}
          />));

    if(getSetting('enable bonification', false) === true) 
      ret.push((<Column
            id="permBonitick"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permBonitick"] ? (
                  <Icon icon="crown" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>Bonitick</Trans>}
              />
            )}
          />));

    if(getSetting('enable external access controle', false) === true)
      ret.push((<Column
            id="permExternAccessCtrl"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permExternAccessCtrl"] ? (
                  <Icon icon="crown" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>external access control</Trans> }
              />
            )}
          />));

    ret.push((<Column
            id="action"
            cellRenderer={(rowIndex) => (
              <Cell>
                <Tag
                  icon="trash"
                  intent="danger"
                  minimal={true}
                  interactive={true}
                  onClick={(event, rowData) => {
                    this.setState({
                      delete: this.state.data[rowIndex],
                      runningDelete: true,
                    });
                  }}
                />
              </Cell>
            )}
            columnHeaderCellRenderer={() => <ColumnHeaderCell />}
          />));
    return ret;
  }
  render() {
    return (
      <Callout title={<Trans>API keys management</Trans>} icon="key">
        {/* creation */}
        <Dialog isOpen={this.state.creating} onClose={this.handleClose}>
          <div className={Classes.DIALOG_FOOTER}>
            <form>
              <FormGroup label={<Trans>label</Trans>} labelFor="login-input">
                <InputGroup
                  id="login-input"
                  onChange={(ti) => {
                    this.setState({ label: ti.target.value });
                  }}
                  type="text"
                />
              </FormGroup>

              <FormGroup label={<Trans>API key</Trans>} labelFor="apikey-input">
                <InputGroup
                  id="apikey-input"
                  value={this.state.apikey}
                  contentEditable={false}
                  rightElement={
                    <Button
                      icon="clipboard"
                      onClick={() =>
                        navigator.clipboard.writeText(this.state.apikey)
                      }
                    />
                  }
                />
              </FormGroup>

              <Callout title={<Trans>permissions</Trans>}>
                <FormGroup>
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="document" />{" "}
                        <Trans>access to financial report</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permFinancial: cb.target.checked });
                    }}
                  />
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="timeline-line-chart" />{" "}
                        <Trans>access to activity report</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permActivity: cb.target.checked });
                    }}
                  />
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="drive-time" />{" "}
                        <Trans>access to the real time supervision</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permSpv: cb.target.checked });
                    }}
                  />

                  <Checkbox
                    label={
                      <span>
                        <Icon icon="crown" />{" "}
                        <Trans>administration permissions</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permAdmin: cb.target.checked });
                    }}
                  />

                  <Checkbox
                    label={
                      <span>
                        <Icon icon="layout-grid" />{" "}
                        <Trans>access to code</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permCode: cb.target.checked });
                    }}
                  />
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="tag" /> <Trans>access to Bonitick</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permBonitick: cb.target.checked });
                    }}
                  />
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="timeline-bar-chart" />{" "}
                        <Trans>access to custom report</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permCustomReport: cb.target.checked });
                    }}
                  />
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="timeline-bar-chart" />{" "}
                        <Trans>access to custom report</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permCustomReport: cb.target.checked });
                    }}
                  />
                  <Checkbox
                    label={
                      <span>
                        <Icon icon="crown" />{" "}
                        <Trans>administration permissions</Trans>
                      </span>
                    }
                    checked={this.state.isEnabled}
                    onChange={(cb) => {
                      this.setState({ permExternAccessCtrl: cb.target.checked });
                    }}
                  />
                  <MultiRouteSelect
                    onSelect={(routes) => {
                      this.setState({ allowedRoutes: routes }, () =>
                       console.log(routes)
                     );
                  }}
                 />
                </FormGroup>
              </Callout>
            </form>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button icon="undo" intent="danger" onClick={this.handleClose} />
              <Button
                icon="add"
                intent="primary"
                onClick={() => {
                  this.setState({ loading: true }, () => {
                    authenticatedPostFetch(
                      "/apikey",
                      {
                        name: this.state.label,
                        apikey: this.state.apikey,
                        permFinancial: this.state.permFinancial,
                        permActivity: this.state.permActivity,
                        permSpv: this.state.permSpv,
                        permCustomReport: this.state.permCustomReport,
                        permAdmin: this.state.permAdmin,
                        permBonitick: this.state.permBonitick,
                        allowedRoutes: this.state.allowedRoutes,
                        permExternAccessCtrl: this.state.permExternAccessCtrl
                      },
                      () => {
                        this.updateTable();
                        this.setState({ creating: false });
                      }
                    );
                  });
                }}
              />
            </div>
          </div>
        </Dialog>

        <Button
          icon="add"
          text="create a new API key"
          onClick={() =>
            this.setState({
              apikey: uuid(),
              creating: true,
            })
          }
        />

        {/* DELETE DIALOG */}
        <Dialog onClose={this.handleClose} isOpen={this.state.runningDelete}>
          <div className={Classes.DIALOG_BODY}>
            <Trans>delete API key</Trans> <b>{this.state.delete.name}</b>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Trans>this operation is irreversible</Trans>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon="undo"
                intent={Intent.DANGER}
                onClick={this.handleClose}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button
                icon="trash"
                onClick={() => {
                  authenticatedDeleteFetch(
                    "/apikey/" + this.state.delete["id"],
                    null,
                    () => {
                      this.updateTable();
                      this.handleClose();
                    }
                  );
                }}
              >
                <Trans>delete</Trans>
              </Button>
            </div>
          </div>
        </Dialog>

        <Table2
          cellRendererDependencies={[this.state.data]}
          numRows={this.state.data.length}
          rowHeaderCellRenderer={(rowIndex) => (
            <RowHeaderCell
              index={rowIndex}
              name={this.state.data[rowIndex]["id"]}
            />
          )}
        >
          <Column
            id="name"
            cellRenderer={(rowIndex) => (
              <Cell>{this.state.data[rowIndex]["name"]}</Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>login</Trans>} />
            )}
          />

          <Column
            id="insertiondate"
            cellRenderer={(rowIndex) => (
              <Cell>
                {new Date(
                  this.state.data[rowIndex]["insertiondate"]
                ).toLocaleString(i18next.language)}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>creation date</Trans>} />
            )}
          />

          <Column
            id="endvalidity"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["endValidity"] !== null ? (
                  new Date(
                    this.state.data[rowIndex]["endValidity"]
                  ).toLocaleString(i18next.language)
                ) : (
                  <Trans>always valid</Trans>
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>end validity</Trans>} />
            )}
          />

          <Column
            key={"peruf"}
            id="permFinancial"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permFinancial"] ? (
                  <Icon icon="document" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to financial report</Trans>}
              />
            )}
          />

          <Column
            key={"perua"}
            id="permActivity"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permActivity"] ? (
                  <Icon icon="timeline-line-chart" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to activity report</Trans>}
              />
            )}
          />

          <Column
            key={"percr"}
            id="permCustomReport"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permCustomReport"] ? (
                  <Icon icon="timeline-bar-chart" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to custom report</Trans>}
              />
            )}
          />

          <Column
            key={"perus"}
            id="permSpv"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permSpv"] ? (
                  <Icon icon="drive-time" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to the real time supervision</Trans>}
              />
            )}
          />

          <Column
            key={"perub"}
            id="permBonitick"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permBonitick"] ? (
                  <Icon icon="tag" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to Bonitick</Trans>}
              />
            )}
          />

          <Column
            key={"peruE"}
            id="permExternAccessCtrl"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["permExternAccessCtrl"] ? (
                  <Icon icon="tag" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>access to external access control</Trans>}
              />
            )}
          />

          <Column
            key={"peraa"}
            id="permAdmin"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["isAdmin"] ? (
                  <Icon icon="crown" intent="success" />
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell
                name={<Trans>administration permissions</Trans>}
              />
            )}
          />

          <Column
            key={"perar"}
            id="allowedRoutes"
            cellRenderer={(rowIndex) => (
              <Cell>
                {this.state.data[rowIndex]["allowedRoutes"] &&
                this.state.data[rowIndex]["allowedRoutes"].length > 0 ? (
                  <span>
                    {this.state.data[rowIndex]["allowedRoutes"].map(function (
                      route
                    ) {
                      return (
                        <div key={route.method + route.path}>
                          <Tag>
                            {methodTag(route.method)}: {route.path}
                          </Tag>
                        </div>
                      );
                    })}
                  </span>
                ) : (
                  <Icon icon="cross" intent="danger" />
                )}
              </Cell>
            )}
            columnHeaderCellRenderer={() => (
              <ColumnHeaderCell name={<Trans>allowed routes</Trans>} />
            )}
          />

          <Column
            id="action"
            cellRenderer={(rowIndex) => (
              <Cell>
                <Tag
                  icon="trash"
                  intent="danger"
                  minimal={true}
                  interactive={true}
                  onClick={(event, rowData) => {
                    this.setState({
                      delete: this.state.data[rowIndex],
                      runningDelete: true,
                    });
                  }}
                />
              </Cell>
            )}
            columnHeaderCellRenderer={() => <ColumnHeaderCell />}
          />
        </Table2>
      </Callout>
    );
  }
}
